import DecimalService from '../decimalService';

export const isNumberGreaterAsDecimals = (a: number, b: number): boolean => {
    const decimalA = DecimalService.parse(a);
    const decimalB = DecimalService.parse(b);

    return DecimalService.isGreater(decimalA, decimalB);
};
